/**
 * Created by roman.kupin on 10/3/2017.
 */

export const PREFIX = "[Contests]";
export const INITIALIZED = `${PREFIX}.Initialized`;

export const UPCOMING_CONTESTS_FETCH = `${PREFIX}UpcomingContestsFetch`;
export const UPCOMING_CONTESTS_FETCH_SUCCESS = `${UPCOMING_CONTESTS_FETCH}Success`;
export const UPCOMING_CONTESTS_FETCH_ERROR = `${UPCOMING_CONTESTS_FETCH}Error`;

export const PAST_CONTESTS_FETCH = `${PREFIX}PastContestsFetch`;
export const PAST_CONTESTS_FETCH_SUCCESS = `${PAST_CONTESTS_FETCH}Success`;
export const PAST_CONTESTS_FETCH_ERROR = `${PAST_CONTESTS_FETCH}Error`;

export const SELECT_UPCOMING = "upcoming";
export const SELECT_PAST = "past";


export function initialized(value) {
    return dispatch => {
        dispatch({type: INITIALIZED, payload: value});
    }
}

export function getContests(propertyUuid, select) {
    return (dispatch) => {
        if (select === SELECT_UPCOMING) {
            return dispatch(getUpcomingContests(propertyUuid));
        } else {
            return dispatch(getPastContests(propertyUuid));
        }
    };
}

export function getUpcomingContests(propertyUuid) {
    return (dispatch, getState, {PhotoContest}) => {
        return PhotoContest.future(propertyUuid)
            .then((response) => {
                dispatch({type: UPCOMING_CONTESTS_FETCH_SUCCESS, payload: response});
                return response;
            })
    };
}

export function getPastContests(propertyUuid) {
    return (dispatch, getState, {PhotoContest}) => {
        return PhotoContest.past(propertyUuid)
            .then((response) => {
                dispatch({type: PAST_CONTESTS_FETCH_SUCCESS, payload: response});
                return response;
            })
    };
}

const All = {initialized, getContests, getUpcomingContests, getPastContests};
export default All;